import React from 'react';
import { SEASONS, useSeason } from '../SeasonContext';
import './SeasonToggle.css';

const SeasonToggle = () => {
  const { season, setSeason } = useSeason();

  return (
    <div className="season-toggle">
      <div className="season-toggle-group" role="group" aria-label="Season">
        {SEASONS.map((year) => (
          <button
            key={year}
            type="button"
            className={`season-toggle-button${season === year ? ' active' : ''}`}
            aria-pressed={season === year}
            onClick={() => setSeason(year)}
          >
            {year}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SeasonToggle;
